<template>
  <div>
    <div
      v-for="(option, index) in options"
      :key="`option-${index}`"
    >
      <div :class="$style.option">
        <input 
          type="radio"
          :id="`${uniqueId}-${index}`"
          :name="uniqueId"
          :class="$style.radio"
          @change="$emit('update:value', option.value)"
        >
        <label
          :for="`${uniqueId}-${index}`"
        >
          {{option.label}}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      validator: value => {
        const obj = value[0]
        return !!obj && typeof obj === 'object' && 'label' in obj && 'value' in obj;
      }
    },
  },
  computed: {
    uniqueId() {
      return `input-${this._uid}`;
    }
  }
}
</script>

<style lang="scss" module>
.option {
  &:not(:last-child) {
    margin-bottom: 4px;
  }
}

.radio {
  position: relative;
  top: 1px;
}
</style>
